/* eslint-disable max-len */
import type { FunctionComponent } from 'react';
import { PageContextType, usePage } from '../../../contexts/PageContext';
import { type RebrandingContextProps, useRebranding } from '../../../contexts/RebrandingContext';
import { PlatformsId } from '../../../../services/types';

const PhoneValidationMP: FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#009EE3" d="M16.504.75c1.243 0 2.25 1.007 2.25 2.25v18c0 1.243-1.007 2.25-2.25 2.25H7.508c-1.242 0-2.25-1.007-2.25-2.25V3c0-1.243 1.008-2.25 2.25-2.25h8.996zm.749 19.501H6.757l.001.749c0 .414.336.75.75.75h8.996c.414 0 .75-.336.75-.75l-.001-.749zm0-15.001H6.757v13.501h10.496V5.25zm-.749-3H7.508c-.414 0-.75.336-.75.75l-.001.75h10.496l.001-.75c0-.414-.336-.75-.75-.75z" />
  </svg>
);

const PhoneValidationCongrats: FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M5.25781 3C5.25836 1.75742 6.26556 0.750667 7.50776 0.750667L16.5038 0.75C17.7465 0.75 18.7538 1.75736 18.7538 3V21C18.7538 22.2426 17.7465 23.25 16.5038 23.25L7.50781 23.2493C6.26556 23.2493 5.25836 22.2426 5.25781 21V3ZM17.2538 5.25V18.752H6.75781L6.75781 5.25H17.2538ZM6.75781 20.252V20.9997C6.758 21.4137 7.09373 21.7493 7.50787 21.7493L16.5038 21.75C16.918 21.75 17.2538 21.4142 17.2538 21V20.252H6.75781ZM17.2538 3.75H6.75781V3.00019C6.75807 2.58618 7.09378 2.25067 7.50781 2.25067L16.5039 2.25C16.918 2.25 17.2538 2.58579 17.2538 3V3.75Z" fill="#00A650" />
  </svg>
);

const PhoneValidationML: FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
    <g fill="none" fillRule="evenodd">
      <g fill="#3483FA" fillRule="nonzero">
        <g>
          <g>
            <g>
              <path d="M16.504.75c1.243 0 2.25 1.007 2.25 2.25v18c0 1.243-1.007 2.25-2.25 2.25H7.508c-1.242 0-2.25-1.007-2.25-2.25V3c0-1.243 1.008-2.25 2.25-2.25h8.996zm.749 19.501H6.757l.001.749c0 .414.336.75.75.75h8.996c.414 0 .75-.336.75-.75l-.001-.749zm0-15.001H6.757v13.501h10.496V5.25zm-.749-3H7.508c-.414 0-.75.336-.75.75l-.001.75h10.496l.001-.75c0-.414-.336-.75-.75-.75z" transform="translate(-28 -337) translate(20 315) translate(0 14) translate(8 8)" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const PhoneValidationSVG: FunctionComponent = () => {
  const { isRebrandingEnabled } = useRebranding() as RebrandingContextProps;
  const { platformId } = usePage() as PageContextType;

  if (platformId === PlatformsId.MP) return isRebrandingEnabled ? <PhoneValidationML /> : <PhoneValidationMP />;

  return <PhoneValidationML />;
};

export const PhoneValidationCongratsSVG: FunctionComponent = () => {
  const { platformId } = usePage() as PageContextType;
  return (platformId === 'ML' || platformId === 'PI' || platformId === 'TC' || platformId === 'MT') ? <PhoneValidationML /> : <PhoneValidationCongrats />;
};
